module.exports = __webpack_public_path__ + "static/media/sanning.509dcf28.mp3";